import { inject, Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LuTypeaheadOptions } from 'src/app/angie-shared/libs/lu-typeahead/lu-typeahead.models';

@Pipe({
	name: 'getSearchInputAriaLabel',
	standalone: true
})
export class GetSearchInputAriaLabelPipe implements PipeTransform {
	translate = inject(TranslateService);
	transform(value: LuTypeaheadOptions, internalSelectedValues: any[], selectedAll: boolean): string {
		const translates = {
			guidance_max_selected: this.translate.instant('lup.typeahead.guidance_max_selected'),
			guidance_disabled: this.translate.instant('lup.a11y.typeahead.guidance_disabled'),
			guidance: this.translate.instant('lup.typeahead.guidance')
		};
		return (value.maxSelections && value.maxSelections === internalSelectedValues.length) || selectedAll
			? translates.guidance_max_selected
			: value.disabled || value.readonly
				? translates.guidance_disabled
				: translates.guidance;
	}
}
